import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PostMerchantFormRequest } from '../shared/PostMerchantRequestForm';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class MerchantRegistrationService {

  

  constructor(private http: HttpClient, private environmentService: EnvironmentService) 
  {
    
  }

  GetMerchantStatus(KeycloakUserId : string) : Observable<Number>
  {
   
    return this
      .http
      .get<Number>(this.environmentService.getConfig('BackendApi') + `api/Merchants/GetMerchantStatus/${KeycloakUserId}`);
  }
  

  SubmitMerchantForm(submittedMerchantForm : PostMerchantFormRequest) : Observable<PostMerchantFormRequest>
  {
    if(submittedMerchantForm.form.MerchantId  > 0)
      return this.http.post<PostMerchantFormRequest>(this.environmentService.getConfig('BackendApi') + 'api/Merchants/Update', submittedMerchantForm.form);
    
    return this
      .http
      .post<PostMerchantFormRequest>(this.environmentService.getConfig('BackendApi') + 'api/Merchants', submittedMerchantForm.form);
      
  }

  

}
